import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from '@gpstrackit/react-controls';
import moment from 'moment';
import Icon from '@mui/material/Icon';
import { Grid } from '@mui/material';
import { copyToClipboard } from 'Core/data/Helpers';
import ChipStatus from 'Components/ChipStatus';

const DETAILS_NOT_SUPPORTED_KEYS = [
    "__typename",
    "Version",
    "EntityId",
    "Id"
];

const DETAILS_MILISECONDS_TIME_KEYS = [
    "lastConnectTime", "lastDisconnectTime", "sysTime", "time", "start", "end",
    "generatedAt", "changedAt", "desiredStarterUpdated", "offsetEcuEngineOdometerUpdatedOn",
    "offsetEngineOdometerUpdatedOn", "offsetEngineHoursUpdatedOn", "offsetEcuEngineHoursUpdatedOn"
];

const DetailView = (props) => {
    const { messages } = useIntl();

    const validateArray = (array) => {
        let elems = [];
        array.forEach(element => {
            if (!element) {
                elems.push(1);
            }
        });

        return array.length === elems.length ? false : true;
    }

    const modelData = (data) => {
        let newData = {};
        if (data) {
            if (typeof data === 'string') {
                return []
            }
            let keys = Object.keys(data);

            keys.forEach(key => {
                let element = data[key];
                //Is an Array and is not empty
                if (Array.isArray(element)) {
                    if (validateArray(element)) {
                        element.map(item => {
                            newData = { ...newData, ...modelData(item) };
                        })
                    }
                } else if (typeof element === 'object') {
                    newData = { ...newData, ...modelData(element) };
                } else {
                    let txtElm = "" + element;
                    let newElms = txtElm.split(";");
                    if (newElms.length > 1) {
                        newElms.forEach(newElm => {
                            let elm = newElm.split(":");
                            if (elm.length > 1) {
                                newData[elm[0]] = elm[1];
                            }
                        });
                    } else {
                        newData[key] = element;
                    }
                }
            });
        }

        return newData;
    }

    const orderData = (data) => {
        let newData = {};

        props.orderData.forEach(field => {
            newData[field] = data[field];
        });

        let keys = Object.keys(data);
        keys.map(key => {
            if (!props.orderData.includes(key)) {
                newData[key] = data[key];
            }
        });

        return newData;
    }

    const getTitle = (key, noTraslate) => {
        let label = noTraslate ? key : messages[key]
        label = label ? label : key;
        let lengthLog = label.length > 15;

        return (
            <Fragment>
                {

                    lengthLog &&
                    //copy to clipboard for recorted elements
                    <div style={{ display: "flex" }}>
                        <Tooltip title={label} style={{ display: "inline-block" }}>
                            <p /* style={{ paddingTop: 3 }} */ className="text-muted">
                                {`${label.substring(0, props.substring || 10)}...`}
                            </p>
                        </Tooltip>
                    </div>
                }
                {
                    !lengthLog &&
                    <p className="text-muted">
                        {label}
                    </p>
                }
            </Fragment>
        )
    }

    const getObjects = (data) => {
        if (data) {

            let keys = Object.keys(data);
            return keys.map((key, index) => {
                let element = data[key];
                if (!DETAILS_NOT_SUPPORTED_KEYS.includes(key)) {
                    if (Array.isArray(element)) {
                        if (validateArray(element)) {
                            return (
                                <Grid item xs={12}>
                                    <hr />
                                    {getTitle(key, props.noTraslate)}
                                    <Grid container>
                                        {
                                            element.map(item => {
                                                return getObjects(item)
                                            })
                                        }
                                    </Grid>
                                    <hr />
                                </Grid>
                            )
                        }
                    } else if (typeof element === 'object') {
                        return (
                            <Fragment>
                                {getObjects(element)}
                            </Fragment>
                        )
                    } else {
                        let txtElm = "" + element;
                        let newElms = txtElm.split(";");
                        let newObj = {};
                        if (newElms.length > 1) {
                            newElms.forEach(newElm => {
                                let elm = newElm.split(":");
                                if (elm.length > 1) {
                                    newObj[elm[0]] = elm[1];
                                }
                            });

                            return (
                                <Fragment>
                                    {getObjects(newObj)}
                                </Fragment>
                            )
                        } else {
                            if (!DETAILS_MILISECONDS_TIME_KEYS.includes(key)) {
                                return (
                                    <Grid item key={index} sm={12} md={props.minimal ? 12 : props?.size || 4}>
                                        <Fragment>
                                            {key && getTitle(key, props.noTraslate)}
                                            {
                                                element && typeof element === 'string' && element.length > 15 &&
                                                //copy to clipboard for recorted elements
                                                <div style={{ display: "flex" }}>
                                                    <span
                                                        style={{ marginRight: 5 }}
                                                        className="cursor-pointer ml-1"
                                                        onClick={() => copyToClipboard(element, messages['common_copied'])}
                                                    >
                                                        <Icon>content_copy</Icon>
                                                    </span>
                                                    <Tooltip title={element} style={{ display: "inline-block" }}>
                                                        <p style={{ paddingTop: 3 }}>
                                                            {`${element.substring(0, props.substring || 10)}...`}
                                                        </p>
                                                    </Tooltip>
                                                </div>
                                            }
                                            {
                                                element && typeof element === 'string' && element.length <= 15 &&
                                                <p>
                                                    {element}
                                                </p>
                                            }
                                            {
                                                element && typeof element === 'number' && key !== "status" &&
                                                <p>
                                                    {element.toString()}
                                                </p>
                                            }
                                            {
                                                element && typeof element === 'number' && key === "status" &&
                                                <p>
                                                    {<ChipStatus statusCode={element} messages={messages} />}
                                                </p>
                                            }
                                            {
                                                typeof element === 'boolean' &&
                                                <p>
                                                    {element.toString()}
                                                </p>
                                            }
                                            {
                                                element === '' &&
                                                <p>{' - '}</p>
                                            }
                                            {
                                                !element || element === 0 &&
                                                typeof element !== 'boolean' &&
                                                <p>
                                                    {' - '}
                                                </p>
                                            }
                                        </Fragment>
                                    </Grid>
                                )
                            }
                            else {
                                return (
                                    <Grid item key={index} sm={12} md={props.minimal ? 12 : props?.size || 4}>
                                        <Fragment>
                                            <p className="text-muted">
                                                {key && getTitle(key, props.noTraslate)}
                                            </p>
                                            <p>
                                                {
                                                    !props.timezone &&
                                                    moment(element).utc().format("YYYY-MM-DD HH:mm:ss z")
                                                }
                                                {
                                                    props.timezone &&
                                                    moment(element).tz(props.timezone).format("YYYY-MM-DD HH:mm:ss z")
                                                }
                                            </p>
                                        </Fragment>
                                    </Grid>
                                );
                            }
                        }
                    }
                }
            });
        }
    }

    let data = null;
    if (props.data) {
        if (props.orderData)
            data = orderData(modelData(props.data));
        else
            data = modelData(props.data)
    }

    return (
        <Grid container>
            {
                data && getObjects(data)
            }
        </Grid>
    )
}

export default DetailView;
